export default class TrackingError extends Error {}
